import React from 'react';
import {
  ABDL_FORM_PAGE_URL,
  ABDL_SERVICES_PAGE_URL,
  CONTACT_PAGE_URL,
  DOM_FORM_PAGE_URL,
  DOMINATION_SERVICES_PAGE_URL,
} from '../../utils/Routes';
import { CompanyEmailAddress, CompanyPhoneNumber } from '../../utils/Constants';
import { Link } from 'react-router-dom';

function HowToBookMainContainer() {
  return (
    <main role='main' className='grid w-full h-full pb-12 pt-12'>
      {/* Form section */}
      <section className='grid w-full'>
        <div className='grid w-full px-6 lg:container lg:mx-auto tracking-wider'>
          <div className='grid gap-y-8 text-center'>
            <h3>
              <em>
                Please select the appropriate booking form for your appointment:
              </em>
            </h3>
            <ul className='list-disc list-inside text-center font-semibold'>
              <li>
                <Link
                  to={DOM_FORM_PAGE_URL}
                  aria-label='Open Domination Booking Form'
                  title='Open Domination Booking Form'
                >
                  Domination Booking Form
                </Link>
              </li>
              <li>
                <Link
                  to={ABDL_FORM_PAGE_URL}
                  aria-label='Open Adult Baby Booking Form'
                  title='Open Adult Baby Booking Form'
                >
                  Adult Baby Booking Form
                </Link>
              </li>
            </ul>

            {/* EMAIL AND PHONE */}
            <section className='grid text-center'>
              <div>
                <h4>
                  If you have any questions or queries, use the form or contact
                  me directly
                </h4>
              </div>
              <div className='grid gap-y-2 pt-4 justify-center text-center font-semibold'>
                <a
                  href={`mailto:${CompanyEmailAddress}`}
                  aria-label={`Email ${CompanyEmailAddress}`}
                  title={`Email ${CompanyEmailAddress}`}
                >
                  Email: {CompanyEmailAddress}
                </a>
                <a
                  href={`tel:${CompanyPhoneNumber}`}
                  aria-label={`Call ${CompanyPhoneNumber}`}
                  title={`Call ${CompanyPhoneNumber}`}
                >
                  Call: {CompanyPhoneNumber}
                </a>
              </div>
            </section>
            <div className='font-extralight grid h-fit gap-y-8'>
              <p>
                If your appointment type is not bookable via the online forms,
                you can{' '}
                <Link
                  to={CONTACT_PAGE_URL}
                  aria-label='Open Contact Page'
                  title='Open Contact Page'
                >
                  <strong>contact me directly</strong>
                </Link>{' '}
                with all requested details.
              </p>

              <p>
                <strong>Services:</strong> See the full list on my <br />
                <Link
                  to={DOMINATION_SERVICES_PAGE_URL}
                  aria-label='Open Domination Services Page'
                  title='Open Domination Services Page'
                >
                  <strong className='font-bold'>Domination Services</strong>
                </Link>{' '}
                <br />
                <Link
                  to={ABDL_SERVICES_PAGE_URL}
                  aria-label='Open ABDL Services Page'
                  title='Open ABDL Services Page'
                >
                  <strong className='font-bold'>ABDL Services</strong>
                </Link>{' '}
                pages.
              </p>
              <p>
                <strong>Availability:</strong> Please make contact to discuss an
                appointment, on occasion same day bookings are available but a
                deposit must be made. All other bookings require advance notice.
              </p>
              <p>
                <strong>Same-Day Sessions:</strong> Specials aren’t available
                same day unless specifically advertised. Same-day bookings must
                be emailed to <strong>{CompanyEmailAddress}</strong> and are at
                Regular Rates.
              </p>
              <p>
                <strong>Fly Me To You (FMTY):</strong> Want a personal encounter
                in your city after an amazing same-day session? Let’s make it
                happen. My FMTY experiences are fully tailored and
                unforgettable. All travel expenses — airfare, hotel, meals,
                transport — are covered separately, and the session tribute is
                negotiated based on location and duration. Advance notice is
                essential, and a non-refundable deposit is required to confirm.
                Submit an inquiry via the{' '}
                <Link
                  to={CONTACT_PAGE_URL}
                  aria-label='Open Contact Page'
                  title='Open Contact Page'
                >
                  <strong>Contact Form</strong>
                </Link>{' '}
                or email <strong>{CompanyEmailAddress}</strong> to start
                planning your exclusive time together.
              </p>
              <p>
                <strong>Payment Methods:</strong> Payment in advance is
                required. <strong>Paypal</strong>,{' '}
                <strong>Bank transfer</strong> is preferred; international
                transfers incur a £5 fee. <strong>Cash</strong> accepted only in
                special cases, not for same-day bookings.{' '}
                <strong>Online vouchers</strong> please enquire which ones i
                currently accept.
              </p>
              <p>
                <strong>Deposit:</strong> A 20% deposit is required. You can
                change your booking with at least 48 hours’ notice (once). The
                remaining balance is due on arrival.
              </p>
              <p>
                <strong>Respectful communication is always appreciated.</strong>
              </p>
              <p>
                <strong>
                  Please confirm your appointment on the day at least two hours
                  prior to your appointment time.
                </strong>
              </p>
              <p>
                <strong>
                  Payment made on arrival and before the session begins.
                </strong>
              </p>
              <p>
                <strong>Text/DM Bookings:</strong> Allowed but Regular Rates
                apply.
              </p>
              <p>
                <strong>Mandatory Info for Booking:</strong> When contacting me,
                please include:
                <br />
                <strong>
                  NAME, PROPOSED DATES/TIMES, DURATION, ACTIVITY INTERESTS,
                  LIMITS/BOUNDARIES, AGE, HOW/WHERE YOU FOUND ME.
                </strong>
                <br />
                Use the{' '}
                <Link
                  to={CONTACT_PAGE_URL}
                  aria-label='Open Contact Page'
                  title='Open Contact Page'
                >
                  <strong>CONTACT FORM</strong>
                </Link>{' '}
                or email <strong>{CompanyEmailAddress}</strong>.
              </p>
              <p>
                <em>
                  <strong>PLEASE CHECK YOUR SPAM FOLDER FOR REPLIES!</strong>
                </em>
              </p>
              <p>
                <strong>Confirming Your Appointment:</strong> Once payment is
                received, you’ll get a confirmation email with venue details and
                instructions. Please call me{' '}
                <strong>at or after your appointed time</strong> only. Early
                calls incur a penalty of £100 per minute.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Tribute Rates Section */}
      <section className='grid w-full px-6 pt-12'>
        <div className='grid px-8 mx-auto py-8 gap-y-4 w-full min-w-xl max-w-3xl text-center text-colour2'>
          <h3 className='text-4xl lg:text-5xl font-titleFont text-colour6 font-semibold'>
            Tribute Rates
          </h3>
          <p className='text-sm lg:text-base leading-relaxed'>
            Sessions start from just <strong>£175</strong>. Tribute rates vary
            depending on the type, length, and intensity of the session, as well
            as any special requests.
          </p>
          <p className='text-sm lg:text-base leading-relaxed'>
            Contact me directly to discuss your ideal session and receive a
            personalized quote.
          </p>
          <div className='grid w-fit mx-auto mt-4'>
            <Link
              to={CONTACT_PAGE_URL}
              className='bg-colour6 hover:brightness-110 text-colour1 text-sm font-serif px-6 py-2 border-2 border-colour2 uppercase'
              aria-label='Enquire about tribute rates with Mistress Maria'
              title='Enquire about tribute rates with Mistress Maria'
            >
              Contact Me
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default HowToBookMainContainer;
